import { render, staticRenderFns } from "./platePopup.vue?vue&type=template&id=e2414aa0&scoped=true"
import script from "./platePopup.vue?vue&type=script&lang=js"
export * from "./platePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2414aa0",
  null
  
)

export default component.exports